var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',_vm._l((_vm.schema),function(field,index){return _c('div',{key:index,staticClass:"col-md-6"},[_c(field.fieldType,_vm._b({tag:"component",attrs:{"value":_vm.value[field.name]},on:{"input":function($event){return _vm.updateForm(field.name, $event)}}},'component',field,false))],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473bd56e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generator/FormGenerator.vue
// module id = null
// module chunks = 